import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0a9e096"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-1" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-1 text-left" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-1 text-center" }, "PJ"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-1 text-center" }, "V-E-D"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-1 text-center" }, "Pts"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-1 text-center" }, "Dif")
  ])
], -1))
const _hoisted_2 = { class: "px-1 text-left" }
const _hoisted_3 = { class: "font-weight-bold" }
const _hoisted_4 = { class: "text-medium-emphasis" }
const _hoisted_5 = { class: "px-1 text-center" }
const _hoisted_6 = { class: "px-1 text-center text-no-wrap" }
const _hoisted_7 = { class: "px-1 text-center font-weight-bold" }
const _hoisted_8 = { class: "px-1 text-center" }
const _hoisted_9 = {
  key: 0,
  class: "text-caption text-medium-emphasis mt-2 text-left"
}


import { FilaClasificacionLiga } from "@/utils/clasificacionLiga";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaClasificacionLiga',
  props: {
    filas: {},
    idUsuario: {},
    clasificados: {},
    sinNota: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_table, {
      density: "compact",
      class: "text-caption"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filas, (fila) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: fila.idUsuario,
              class: _normalizeClass({ 'fila-propia': fila.idUsuario === _ctx.idUsuario })
            }, [
              _createElementVNode("td", {
                class: _normalizeClass(["px-1", { 'fila-clasificada': _ctx.clasificados?.includes(fila.idUsuario) }])
              }, _toDisplayString(fila.posicion), 3),
              _createElementVNode("td", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(fila.nick), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(fila.ejercito), 1)
              ]),
              _createElementVNode("td", _hoisted_5, _toDisplayString(fila.jugadas), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(fila.victorias) + "-" + _toDisplayString(fila.empates) + "-" + _toDisplayString(fila.derrotas), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(fila.puntos), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(fila.diferencia), 1)
            ], 2))
          }), 128))
        ])
      ]),
      _: 1
    }),
    (!_ctx.sinNota)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Solo cuentan las partidas validadas por los dos jugadores. Desempate: puntos, diferencia, puntos a favor y generales. "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})